import { Location } from '@angular/common';
import { Component, EventEmitter, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import * as _ from 'underscore';
import { Auth } from '../shared/services/auth';
import { Configuration } from '../shared/services/configuration';
import { HttpClientCustom } from '../shared/services/http.client';
import { SharedData } from '../shared/sharedData';
import { ToasterComponent } from '../toasterComponent/toasterComponent';
import { isString } from 'util';

@Component({
  selector: 'AddMgrLevel',
  templateUrl: 'addMgrLevel.html'
})
export class AddManagerLevelComponent {

  public _baseUrl: any;
  public type: any = 'ADD';
  public mgrLevelModel: any;
  public empPresent: boolean = false;
  public data: any;
  public mgrdata: any = {};

  constructor(
    public route: ActivatedRoute,
    public modalService: NgbModal,
    public _global: Configuration,
    public http: HttpClientCustom,
    public _sanitizer: DomSanitizer,
    public builder: FormBuilder,
    public _auth: Auth,
    public router: Router,
    public _location: Location,
    public share: SharedData,
    public _toaster: ToasterComponent,
    public translate: TranslateService,
    vcr: ViewContainerRef) {

    this._baseUrl = _global.get('EPMS_BASE_URL');
    let data: any = this.share.getData();
    if (_.isEmpty(data)) {
      this._location.back();
    } else {
      if (data.type === 'ADD') {
        this.data = {};
        this.type = 'ADD';
      } else if (data.type === 'EDIT') {
        this.mgrdata = data.mgrdata;
        this.type = 'EDIT';
      } else {
        this.mgrdata = data.mgrdata;
        this.type = 'DELETE';

        let url = this._baseUrl + 'v1/webAdmin/managerLevel/check/' + this.mgrdata.id;
        this.http.get(url).subscribe((result) => {
          if (result.success) {
            this.empPresent = true;
          } else {
            this.empPresent = false;
          }
        });
      }
    }
    this._toaster.setViewRef(vcr);
  }

  // Formatter
  public nameValueFormatter(data: any): string {
    return `${data.name}`;
  }
  public typeValueFormatter(data: any): string {
    return `${data.type}`;
  }
  public autoCompleteListMgrLevelFormatter = (data: any): SafeHtml => {
    let html = `<span>${data.name}</span>`;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }

  // when auto-complete value is 
  // selected this method fires and payload create
  public gotNewValue(e) {
    this.mgrLevelModel = e;
  }

  // T0 get list of designation based on keyword
  public mgrLevelObservableSource = (keyword: any): Observable<any[]> => {
    let url = this._baseUrl + 'v1/webAdmin/managerLevel/managerLevelSearch';
    url += '?searchString=' + keyword + '&id=' + this.mgrdata.id;
    if (keyword.trim()) {
      return this.http.get(url)
        .map((res) => {
          return res;
        }, (error) => {
          return Observable.of([]);
        });
    } else {
      return Observable.of([]);
    }
  }

  // navigate back
  public goToBackPage() {
    this._location.back();
  }

  public saveDesgData() {
    if (this.validateManagerLevel()) {
      let url = this._baseUrl + 'v1/webAdmin/managerLevel/save';
      this.http.post(url, this.mgrdata).subscribe((result) => {
        if (result.success) {
          this.translate.get('empTypeSaved').subscribe((msg) => {
            this._toaster.showSuccess(msg);
          });
          setTimeout(() => this.goToBackPage(), 1000);
        } else {
          this.translate.get(result.errorMessages[0]).subscribe((msg) => {
            this._toaster.showError(msg);
          });
        }
      }, (error) => {
        this.translate.get('errorWhileSavingEmployeeType').subscribe((msg) => {
          this._toaster.showError(msg);
        });
      });

    }

  }

  public isEmpty(val) {
    return !val
      || (isString(val) && !val.trim());
  }

  public deleteDesgData() {
    if (this.empPresent) {
      if (this.empPresent && this.isEmpty(this.mgrLevelModel)) {
        this.translate.get('selectAltEmpType').subscribe((msg) => {
          this._toaster.showError(msg);
        });
        return false;
      }
    }
    let url;
    if (this.empPresent) {
      url = this._baseUrl + 'v1/webAdmin/managerLevel/'
        + this.mgrdata.id + '?alternateId=' + this.mgrLevelModel.id;
    } else {
      url = this._baseUrl + 'v1/webAdmin/managerLevel/' + this.mgrdata.id;
    }
    this.http.delete(url).subscribe((result) => {
      if (result.success) {
        this.translate.get('empTypeDeleted').subscribe((msg) => {
          this._toaster.showSuccess(msg);
        });
        setTimeout(() => this.goToBackPage(), 1000);
      } else {
        this.translate.get(result.errorMessages[0]).subscribe((msg) => {
          this._toaster.showError(msg);
        });
      }
    }, (error) => {
      this.translate.get('errorWhileDeleteEmployeeType').subscribe((msg) => {
        this._toaster.showError(msg);
      });
    });
  }

  public validateManagerLevel() {

    if (!this.mgrdata.name || !this.mgrdata.name.trim()) {
      this.translate.get('enterEmpTypeName').subscribe((msg) => {
        this._toaster.showError(msg);
      });
      return false;
    }
    if (!this.mgrdata.code || !this.mgrdata.code.trim()) {
      this.translate.get('enterEmpTypeCode').subscribe((msg) => {
        this._toaster.showError(msg);
      });
      return false;
    }
    if (!this.mgrdata.level || this.mgrdata.level < 1) {
      this.translate.get('pleaseEnterLevelGreaterThanZero').subscribe((msg) => {
        this._toaster.showError(msg);
      });
      return false;
    }
    if (this.mgrdata.level > 100) {
      this.translate.get('pleaseEnterLevelLessHund').subscribe((msg) => {
        this._toaster.showError(msg);
      });
      return false;
    }
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/tools/addMgrLevel.ts